import styles from "./no-desktop-screen.module.css"
import FlipPhoneIcon from "@/components/under-construction/flip-phone-icon.tsx"
import useDeviceBreakpoint from "@/hooks/use-device-breakpoint.ts"
import useIsPortrait from "@/hooks/use-is-portrait.ts"

const LandscapeBlock = () => {
  const isPortrait = useIsPortrait()
  const { isDesktop, isTablet } = useDeviceBreakpoint()

  if (isDesktop || isTablet) {
    return null
  }

  if (isPortrait) {
    return null
  }

  return (
    <div className={styles.wideScreenMessage}>
      <div className={styles.wideScreenMessageContent}>
        <FlipPhoneIcon />
      </div>
    </div>
  )
}

export default LandscapeBlock
